// utils/toast.js
// Global toast event bus — works without React context, callable from anywhere.

const listeners = new Set();
let _id = 0;

export function toast(message, type = 'success', duration = 4000) {
  const id = ++_id;
  listeners.forEach(fn => fn({ id, message, type, duration }));
  return id;
}

export function toastSuccess(message, duration) { return toast(message, 'success', duration); }
export function toastError  (message, duration) { return toast(message, 'error',   duration); }
export function toastInfo   (message, duration) { return toast(message, 'info',    duration); }
export function toastWarning(message, duration) { return toast(message, 'warning', duration); }

export function _subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); }